"use client"

import { Disc3 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Disc3Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Disc3Icon = component(Icon)({ as: Disc3 })
